export const cs = {
    Lang_cs: "Česky",
    Lang_en: "Anglicky",
    button_Pokracovat: "Pokračovat",
    button_Close: "Zavřít",
    button_Ok: "Ok",
    SetFirstPassword_DokladFill: "Pro pokračování prosím vyplňte číslo dokladu",
    button_Update: "Upravit",
    button_Save: "Uložit",
    button_cancel: "Zrušit",
    TypOvereniSubjektu: "Způsob ověření",
    TypOvereniSubjektu_DOKLAD_CISLO: "Doklad",
    TypOvereniSubjektu_JMENO_PRIJMENI_DATUMNAR: "Jméno, příjmení a datum narození",
    SetFirstPassword_Overeni: "Pro pokračování prosím vyplňte údaje pro ověření",
    SetFirstPassword_HesloNastaveno: "Heslo bylo nastaveno.",
    Form_HeslaNeshoduji: "Hesla se neshodují",
    TypDokladu_ID: "Občanský průkaz",
    TypDokladu_P: "Cestovní doklad",
    TypDokladu_OSTATNI: "Ostatní",
    TypDokladu_IR: "Povolení k pobytu",
    TypDokladu_VS: "Vízový štítek",
    TypDokladu_PS: "Pobytový štítek",
    TypDokladu_RP: "Řidičský průkaz",
    DokladForm_idDoklad_required: "Číslo dokladu je povinné",
    DokladForm_idDoklad_minLength: "Číslo dokladu musí mít minimálně 8 znaků",
    DokladForm_idDoklad_maxLength: "Číslo dokladu nesmí být delší než 9 znaků",
    DokladForm_typDokladu_required: "Typ dokladu je povinný",
    DokladForm_typOvereniSubjektu_required: "Způsob ověření je povinný",
    DokladForm_jmeno_required: "Jméno je povinné",
    DokladForm_prijmeni_required: "Příjmení je povinné",
    DokladForm_datumNarozeni_required: "Datum narození je povinný",
    DokladForm_cisloDokladu: "Číslo dokladu",
    DokladForm_jmeno: "Jméno",
    DokladForm_prijmeni: "Příjmení",
    DokladForm_datumNarozeni: "Datum narození",
    NewPasswordForm_newPassword: "Nové heslo",
    NewPasswordForm_newPassword_repeat: "Nové heslo znovu",
    UserAgreementFormSection_agreement: "Souhlasím se {1} a {2}.",
    UserAgreementFormSection_gdpr: "zpracováním osobních údajů",
    UserAgreementFormSection_terms: "podmínkami užívání portálu",
    UserAgreementFormSection_agreement2: "Souhlasím se {1}.",
    UserAgreementFormSection_gdpr_and_terms: "zpracováním osobních údajů a podmínkami užívání portálu",
    UserAgreementFormSection_gdpr_detail: "Souhlas se zpracováním osobních údajů",
    UserAgreementFormSection_terms_detail: "Souhlas s podmínkami užívání portálu",
    ProcessLoginForm_cisloDokladu_required: "Zadejte číslo dokladu",
    ProcessLoginForm_finish_disabled: "Pro pokračování prosím ověřte e-mail",
    Form_agreement_required: "Musíte souhlasit se zpracováním osobních údajů a podmínkami užívání portálu.",
    NewPasswordForm_newPassword_required: "Heslo je povinné",
    NewPasswordForm_newPassword_repeat_required: "Heslo znovu je povinné",
    ResetPasswordPage_obnoveniHesla: "Obnovení hesla",
    ResetPasswordPage_done: "Pokud je e-mail registrován u aktivního účtu, byl Vám odeslán e-mail s informací k obnově hesla.",
    ResetPasswordForm_login: "Přihlašovací jméno",
    ResetPasswordForm_login_required: "Přihlašovací jméno je povinné",
    ResetPasswordForm_captcha_required: "Ověření zda nejste robot je povinné",
    Altcha_label: "Nejsem robot",
    Altcha_verified: "Ověřeno",
    Altcha_verifying: "Ověřuji...",
    Altcha_error: "Ověření selhalo.",
    Altcha_expired: "Ověření vypršelo.",
    ResetPasswordForm_info: "Zadejte přihlašovací jméno. Na registrovaný email Vám budou odeslány informace pro obnovení hesla.",
    ResetPasswordForm_button_obnovitHeslo: "Obnovit heslo",
    PasswordChangePage_title: "Nastavení hesla",
    NewPasswordForm_button_nastavitHeslo: "Nastavit heslo",
    PasswordChangePage_hesloNastaveno: "Heslo bylo nastaveno. Nyní se můžete přihlásit.",
    PasswordChangePage_continueLogin: "Pokračovat na přihlášení",
    TypAutentizace_JMENO_HESLO: "Uživatelské jméno ({0}) a heslo",
    TypAutentizace_NIA: "Identita občana",
    TypAutentizace_MOJE_ID: "MojeID",
    TypAutentizace_ISDS: "Datová schránka",
    TypAutentizace_JMENO_HESLO_INVALID: "Jméno a heslo není nastaveno.",
    TypAutentizace_NIA_INVALID: "eidentita nebyla připojena.",
    TypAutentizace_MOJE_ID_INVALID: "Účet MojeID nebyl připojen.",
    TypAutentizace_ISDS_INVALID: "Účet datové schránky nebyl připojen.",
    ProcessLoginPage_procesPrihlaseni: "Proces přihlášení",
    ProcessLoginPage_chybaPrihlaseni: "Chyba přihlášení",
    ProcessLoginForm_button_dokoncitPrihlaseni: "Dokončit přihlášení",
    ProcessLoginPage_action_opakovatPrihlaseni: "Opakovat přihlášení",
    ProcessLoginPage_action_zmenitPrihlaseni: "Změnit způsob přihlášení",
    ProcessLoginPage_loginError: "Přihlášení selhalo, opakujte akci později.",
    ProcessLoginPage_maloDat1: "Nebyly předány povinné položky pro přihlášení.",
    ProcessLoginPage_maloDat2: "Prosím opakujte přihlášení.",
    ProcessLoginPage_registraceJmenoHesloNotSupported: "Registrace pomocí uživatelského jména a hesla je dostupná pouze na přepážce úřadu.",
    ProcessLoginPage_nepredano: "nepředáno",
    ProcessLoginPage_predano: "předáno",
    ProcessLoginPage_malaUroven: "účet nemá dostatečnou úroveň ověření",
    ProcessLoginPage_jmeno: "Jméno",
    ProcessLoginPage_prijmeni: "Příjmení",
    ProcessLoginPage_datumNarozeni: "Datum narození",
    ProcessLoginPage_adresa: "Adresa",
    ProcessLoginPage_urovenDuveryhodnosti: "Úroveň důvěryhodnosti",
    ProcessLoginPage_nodata_jmenoPrijmeni: "Jméno a příjmení nebylo předáno",
    ProcessLoginPage_nodata_adresa: "Adresa nebyla předána",
    ProcessLoadingPage: "Načítání...",
    Validation_fieldRequired: "Položka je povinná",
    Validation_telefonFormat: "Telefon nemá správný formát",
    Validation_emailFormat: "Email nemá správný formát",
    WaitingMessage: "Probíhá zpracování požadavku...",
    MoreInformation: "Více informací",
    TypNotifikace_TELEFON: "Notifikace telefon",
    TypNotifikace_EMAIL: "Notifikace e-mail",
    TypNotifikace_HROMADNE_OSLOVENI: "Souhlasím s předáním osobních údajů do systému pro hromadné oslovení osob",
    TypNotifikace_Verify_TELEFON: "Po ověření vám budou na uvedený telefon zasílány notifikace z Portálu občana",
    TypNotifikace_Verify_EMAIL: "Po ověření vám budou na uvedený e-mail zasílány notifikace z Portálu občana.",
    TypNotifikace_SendAgain_TELEFON: "Zaslat sms znovu",
    TypNotifikace_SendAgain_EMAIL: "Zaslat e-mail znovu",
    TypNotifikace_RemainingAttempts_TELEFON: "Zbývající počet pokusů: {0}",
    TypNotifikace_RemainingAttempts_NO_TELEFON: "Vyčerpali jste maximální počet pokusů na zadání kódu, vyžádejte si prosím nový kód",
    TypNotifikace_SendAgain_Info_TELEFON: "Na uvedený telefon '{0}' vám byl zaslán ověřovací kód. Prosíme vás o jeho zadání.",
    TypNotifikace_SendAgain_Info_EMAIL: "Na uvedený e-mail '{0}' vám byl zaslán ověřovací kód. Prosíme vás o jeho zadání.",
    TypNotifikace_Sent_TELEFON: "Byla odeslaná nová SMS s ověřovacím kódem na váš mobilní telefon.",
    TypNotifikace_Sent_EMAIL: "Byl odeslán nový email s ověřovacím kódem na adresu",
    TypSouhlasu_REG_GDPR_UCET: "Zpracování osobních údajů",
    TypSouhlasu_REG_PLNA_MOC_PORTAL: "Plná moc",
    TypSouhlasu_REG_PODMINKY_PORTAL: "Podmínky užívání portálu",
    TypSouhlasu_REG_PODMINKY_GDPR_PORTAL_PAGE: "Podmínky užívání portálu a zpracování osobních údajů",
    ProfilePage_documentDownloading: "Stahování dokumentu",
    ProfilePage_stavNotActivated: "Účet zatím nebyl aktivován, vyčkejte na obrdržení aktivačního kódu.",
    ProfilePage_mujProfil: "Můj profil",
    ProfilePage_ucetDelete: "Trvale odstranit účet",
    ProfilePage_ucetDeleteTitle: "Trvale odstranit účet?",
    ProfilePage_ucetDeleteQuestion1: "Pozor, tato operace je nevratná! Účet bude natrvalo odstraněn včetně všech zastupovaných subjektů.",
    ProfilePage_ucetDeleteQuestion2: "Pozor, tato operace je nevratná! Účet bude natrvalo odstraněn.",
    ProfilePage_ucetDeleteAction: "Trvale odstranit",
    ProfilePage_ucetDeleteSuccessTitle: "Smazání účtu",
    ProfilePage_ucetDeleteSuccessMessage: "Smazání vašeho účtu proběhlo úspěšně.",
    ProfilePage_actionFailed: "Zpracování akce selhalo.",
    ProfilePage_loginTypes: "Způsoby přihlášení",
    ProfilePage_actionInaccessible: "Akce není z důvodů prováděné údržby aktuálně dostupná.",
    ProfilePage_dataInaccessible: "Některá data a akce nejsou z důvodů prováděné údržby aktuálně dostupná.",
    ProfilePage_notificationReminder: "Zapněte si zasílání notifikací přehledů plateb a vyúčtování. Včas vám vše připomeneme.",
    ProfilePage_baseEditEmailTitle: "Upravit e-mail",
    ProfilePage_baseEditTelefonTitle: "Upravit telefon",
    ProfilePage_baseTitle: "Základní údaje",
    ProfilePage_baseJmenoPrijmeni: "Jméno a příjmení",
    ProfilePage_baseDatumNarozeni: "Datum narození",
    ProfilePage_baseAdresa: "Adresa",
    ProfilePage_baseDoklad: "Doklad totožnosti",
    ProfilePage_baseEmail: "E-mail",
    ProfilePage_baseTelefon: "Telefon",
    ProfilePage_baseSouhlasy: "Souhlasy",
    ProfilePage_baseKontaktyAktualizovany: "Kontaktní údaje byly aktualizovány",
    ProfilePage_baseKontaktyTitle: "Kontakty",
    ProfilePage_baseYmenitKontakty: "Změnit kontakty",
    ProfilePage_loginType: "Způsob přihlášení",
    ProfilePage_loginRegistered: "Registrace",
    ProfilePage_loginLastLogin: "Poslední přihlášení",
    ProfilePage_changePassword: "Změnit heslo",
    ProfilePage_smsConfirm: "Ověření pomocí SMS",
    ProfilePage_smsConfirmEnterCode: "Zadejte 4místný kód, který jsme odeslali na váš mobilní telefon {0}",
    ProfilePage_smsConfirmEnterCodeRemainingAttempts: "Zbývající počet pokusů: {0}",
    ProfilePage_smsConfirm_SendAgain: "Zaslat sms znovu",
    ProfilePage_smsConfirmRemainingAttempts_NO: "Vyčerpali jste maximální počet pokusů na zadání kódu, vyžádejte si prosím nový kód",
    ProfilePage_smsConfirmVerify: "Ověřit kód",
    ProfilePage_smsConfirmCodePlaceholder: "Ověřovací kód",
    ProfilePage_smsConfirmCodeNotValid: "Zadaný SMS kód není správný",
    ProfilePage_smsConfirm_Sent: "Byla odeslaná nová SMS s ověřovacím kódem na váš mobilní telefon",
    ProfilePage_passwordChangeDialogTitle: "Změna hesla",
    ProfilePage_passwordChangeCurrentPassword: "Aktuální heslo",
    ProfilePage_passwordChangeNewPassword: "Nové heslo",
    ProfilePage_passwordChangeNewPassword2: "Nové heslo znovu",
    ProfilePage_passwordChangeDo: "Změnit",
    ProfilePage_passwordChangeNoNewAttempts: "Byly vyčerpány všechny pokusy změny hesla, akce bude dostupná později.",
    ProfilePage_passwordChangeNoNewAttemptsTitle: "Vyčerpaný počet pokusů změny hesla",
    ProfilePage_passwordChanged: "Heslo bylo změněno",
    ProfilePage_notificationOvereni: "Ověření kontaktu",
    ProfilePage_notificationEnabled: "Aktivní",
    ProfilePage_notificationDisabled: "Neaktivní",
    ProfilePage_notificationEnable: "Zapnout",
    ProfilePage_notificationDisable: "Vypnout",
    ProfilePage_notificationChange: "Změnit",
    ProfilePage_notificationVerify: "Ověřit",
    ProfilePage_notificationVerified: "Ověřeno",
    ProfilePage_notificationNezobrazovatNotifikace: "Příště nezobrazovat",
    ProfilePage_notificationSkipSettings: "Přeskočit nastavení",
    ProfilePage_notificationKontaktNotVerified: "Kontakt není ověřen",
    ProfilePage_notificationEnableTitle: "Zapnutí notifikací",
    ProfilePage_emailVerificationTitle: "Ověření e-mailu",
    ProfilePage_notificationVerifyVerifyAndEnable: "Ověřit a zapnout",
    ProfilePage_notificationVerifyTitle: "Zapnutí notifikací",
    ProfilePage_notificationWrongCode: "Kód není správný",
    ProfilePage_pristupyLabel: "Osoby, k jejichž datům mám přístup",
    ProfilePage_pristupyAdd: "Přidat osoby",
    ProfilePage_pristupyAddDeti: "Nezletilé děti",
    ProfilePage_pristupyAddOsvc: "OSVČ",
    ProfilePage_pristupyPerson: "Další fyzické osoby",
    ProfilePage_pristupyDatumZadosti: "Datum podání žádosti",
    ProfilePage_pristupyDatumZadostiBez: "Bez žádosti",
    ProfilePage_pristupyEmail: "E-mail",
    ProfilePage_pristupyTyp: "Typ přístupu",
    ProfilePage_pristupyTypVazby: "Typ vazby",
    ProfilePage_pristupyDokumenty: "Dokumenty",
    ProfilePage_pristupyDalsi: "Další přístupy",
    ProfilePage_pristupyAddPristup: "Přidat přístup",
    ProfilePage_pristupyTypOboustranny: "Oboustranný",
    ProfilePage_pristupyTypJednostranny: "Jednostranný",
    ProfilePage_pristupy_AddOSVC: "Přidat přístup k OSVČ",
    ProfilePage_pristupy_AddChild: "Přidat přístup k nezletilému dítěti",
    ProfilePage_pristupy_AddFO: "Přidat přístup k fyzické osobě",
    ProfilePage_pristupy_deleteTitle: "Trvale odstranit přístup?",
    ProfilePage_pristupy_deleteQuestion: "Přejete si opravdu odstranit přístup?",
    ProfilePage_pristupy_delete: "Odstranit přístup",
    ProfilePage_pristupy_zadostPrijmout: "Přijmout",
    ProfilePage_pristupy_zadostZamitnout: "Zamítnout",
    ProfilePage_pristupy_zadostQuestion: "Přejete si opravdu '{0}' žádost o přístup?",
    ProfilePage_pristupy_zadostTitleAccept: "Přijetí žádosti o přístup",
    ProfilePage_pristupy_zadostTitleReject: "Zamítnutí žádosti o přístup",
    ProfilePage_pristupy_zadostStornoQuestion: "Přejete si opravdu stornovat žádost o přístup?",
    ProfilePage_pristupy_zadostStornoTitle: "Stornovat žádost o přístup?",
    ProfilePage_pristupy_zadostStorno: "Stornovat",
    ProfilePage_pristupy_zadostDatumVyprseni: "Datum vypršení žádosti",
    ProfilePage_ucetAktivace: "Aktivace účtu",
    ProfilePage_ucetAktivovan: "Účet byl aktivován",
    ProfilePage_ucetAktivaceDesc: "Pro dokončení registrace zadejte aktivační kód.",
    ProfilePage_ucetAktivaceKod: "Aktivační kód",
    ProfilePage_ucetAktivaceAktivovat: "Aktivovat",
    TypVazbyInfo_SAM_K_SOBE: "Sám k sobě",
    TypVazbyInfo_PRIMY_ZASTUPCE: "Přímý zástupce",
    TypVazbyInfo_NEPRIMY_ZASTUPCE: "Nepřímý zástupce",
    TypVazbyInfo_RODIC: "Rodič",
    SubjektForm_ico: "IČO",
    SubjektForm_jmeno: "Jméno",
    SubjektForm_prijmeni: "Příjmení",
    SubjektForm_datumNarozeni: "Datum narození",
    SubjektForm_pristup_oboustrannyPristup: "Oboustranný přístup",
    SubjektForm_adresa: "Adresa",
    SubjektForm_adresaSearch: "Vyhledat adresu...",
    SubjektForm_IsChildValidation: "Dítě musí být mladší 18 let",
    SubjektForm_datumNarozeniMinulost: "Datum narození musí být v minulosti",
    SubjektForm_email: "E-mail",
}
